"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  VoiceId: ['voice-id', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4,9v6a1,1,0,0,0,2,0V9A1,1,0,0,0,4,9Z', 'M8.5,6.5a1,1,0,0,0-1,1v9a1,1,0,0,0,2,0v-9A1,1,0,0,0,8.5,6.5Z', 'M20,15V9a1,1,0,0,0-2,0v6a1,1,0,0,0,2,0Z', 'M16.5,7.5a1,1,0,0,0-2,0v9a1,1,0,0,0,2,0Z', 'M12,3.5a1,1,0,0,0-1,1v15a1,1,0,0,0,2,0V4.5A1,1,0,0,0,12,3.5Z', 'M6.5,22H2.25A.25.25,0,0,1,2,21.75V17.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H6.5a1,1,0,0,0,0-2Z', 'M1,7.5a1,1,0,0,0,1-1V2.25A.25.25,0,0,1,2.25,2H6.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V6.5A1,1,0,0,0,1,7.5Z', 'M23,16.5a1,1,0,0,0-1,1v4.25a.25.25,0,0,1-.25.25H17.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V17.5A1,1,0,0,0,23,16.5Z', 'M22,0H17.5a1,1,0,0,0,0,2h4.25a.25.25,0,0,1,.25.25V6.5a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z']],
  VoiceIdUser: ['voice-id-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.028,2.5a1,1,0,0,0-1,1v14a1,1,0,0,0,2,0V3.5A1,1,0,0,0,1.028,2.5Z', 'M4.528,6.5a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0v-6A1,1,0,0,0,4.528,6.5Z', 'M8.028,5a1,1,0,0,0-1,1v9a1,1,0,1,0,2,0V6A1,1,0,0,0,8.028,5Z', 'M12.528,1a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0Z', 'M22.028,10.5a1,1,0,0,0,1-1v-6a1,1,0,0,0-2,0v6A1,1,0,0,0,22.028,10.5Z', 'M18.528,9.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,18.528,9.5Z', 'M15.028,10.5a1,1,0,0,0,1-1V6a1,1,0,1,0-2,0V9.5A1,1,0,0,0,15.028,10.5Z', 'M23.922,22.983a6.126,6.126,0,0,0-3.829-3.677.25.25,0,0,1-.029-.465,4.253,4.253,0,1,0-3.618-.024.25.25,0,0,1-.034.464,6.121,6.121,0,0,0-3.891,3.7.749.749,0,0,0,.7,1.017h10a.75.75,0,0,0,.7-1.017ZM16.028,15a2.145,2.145,0,0,1,.126-.72.252.252,0,0,1,.366-.131A5.648,5.648,0,0,0,19.464,15a5.215,5.215,0,0,0,.764-.056.25.25,0,0,1,.286.266A2.248,2.248,0,0,1,16.028,15Z']],
  VoiceIdDenied: ['voice-id-denied', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm1.591,6.677,1.237,1.237a1,1,0,1,1-1.414,1.414l-1.237-1.237a.25.25,0,0,0-.354,0l-1.237,1.237a1,1,0,1,1-1.414-1.414l1.237-1.237a.25.25,0,0,0,0-.354l-1.237-1.237a1,1,0,0,1,1.414-1.414l1.237,1.237a.25.25,0,0,0,.354,0l1.237-1.237a1,1,0,1,1,1.414,1.414l-1.237,1.237A.25.25,0,0,0,19.091,17.677Z', 'M1,2.5a1,1,0,0,0-1,1v14a1,1,0,0,0,2,0V3.5A1,1,0,0,0,1,2.5Z', 'M4.5,6.5a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0v-6A1,1,0,0,0,4.5,6.5Z', 'M8,5A1,1,0,0,0,7,6v9a1,1,0,0,0,2,0V6A1,1,0,0,0,8,5Z', 'M22,10.5a1,1,0,0,0,1-1v-6a1,1,0,0,0-2,0v6A1,1,0,0,0,22,10.5Z', 'M12.5,11V1a1,1,0,0,0-2,0V11a1,1,0,0,0,2,0Z', 'M18.5,9.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,18.5,9.5Z', 'M15,10a1,1,0,0,0,1-1V6a1,1,0,0,0-2,0V9A1,1,0,0,0,15,10Z']],
  VoiceIdLock: ['voice-id-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1,2.5a1,1,0,0,0-1,1v14a1,1,0,0,0,2,0V3.5A1,1,0,0,0,1,2.5Z', 'M4.5,6.5a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0v-6A1,1,0,0,0,4.5,6.5Z', 'M8,5A1,1,0,0,0,7,6v9a1,1,0,0,0,2,0V6A1,1,0,0,0,8,5Z', 'M11.5,0a1,1,0,0,0-1,1V20a1,1,0,0,0,2,0V1A1,1,0,0,0,11.5,0Z', 'M21.162,9.816a4.381,4.381,0,0,1,1,.563.25.25,0,0,0,.254.026A.994.994,0,0,0,23,9.5v-6a1,1,0,0,0-2,0v6c0,.035,0,.072,0,.108A.25.25,0,0,0,21.162,9.816Z', 'M17.85,9.551A4.373,4.373,0,0,1,18.5,9.5h.7a.249.249,0,0,0,.234-.161A.944.944,0,0,0,19.5,9V7.5a1,1,0,0,0-2,0V9a1.025,1.025,0,0,0,.082.4A.251.251,0,0,0,17.85,9.551Z', 'M14.577,11.4a.251.251,0,0,0,.307-.079,4.41,4.41,0,0,1,1.01-.989.249.249,0,0,0,.106-.2V6a1,1,0,0,0-2,0v4.5A.994.994,0,0,0,14.577,11.4Z', 'M22.714,15.515a.249.249,0,0,1-.214-.247V14.25a3.5,3.5,0,0,0-7,0v1.018a.249.249,0,0,1-.214.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.714,15.515ZM19,21.25a1,1,0,1,1,1-1A1,1,0,0,1,19,21.25Zm1.5-6a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1a1.5,1.5,0,0,1,3,0Z']],
  VoiceIdSmartphone: ['voice-id-smartphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,0H7A3,3,0,0,0,4,3V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V3A3,3,0,0,0,17,0Zm1,19a.5.5,0,0,1-.5.5H6.5A.5.5,0,0,1,6,19V3.5A.5.5,0,0,1,6.5,3h11a.5.5,0,0,1,.5.5Z', 'M8.5,9a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V10A1,1,0,0,0,8.5,9Z', 'M15.5,9a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V10A1,1,0,0,0,15.5,9Z', 'M12,6.5a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0v-8A1,1,0,0,0,12,6.5Z']],
  VoiceIdApproved: ['voice-id-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1,2.5a1,1,0,0,0-1,1v14a1,1,0,0,0,2,0V3.5A1,1,0,0,0,1,2.5Z', 'M4.5,6.5a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0v-6A1,1,0,0,0,4.5,6.5Z', 'M8,5A1,1,0,0,0,7,6v9a1,1,0,0,0,2,0V6A1,1,0,0,0,8,5Z', 'M22,10.5a1,1,0,0,0,1-1v-6a1,1,0,0,0-2,0v6A1,1,0,0,0,22,10.5Z', 'M12.5,11V1a1,1,0,0,0-2,0V11a1,1,0,0,0,2,0Z', 'M18.5,9.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,18.5,9.5Z', 'M15,10a1,1,0,0,0,1-1V6a1,1,0,0,0-2,0V9A1,1,0,0,0,15,10Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3.474,5.355-2.905,3.874a1.751,1.751,0,0,1-2.64.185l-1.5-1.5A1,1,0,0,1,15.344,17.5l1.094,1.094a.25.25,0,0,0,.377-.026l2.559-3.413a1,1,0,1,1,1.6,1.2Z']]
};
exports["default"] = _default;